import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { getUserData } from "../../../app/UrlCrud";
import ReportPageForm from "./ReportPageForm";
import "./index.scss";

/**
 * Thin wrapper: resolves the asset-owner id in the URL, shows loading/
 * invalid-link states, and otherwise hands off entirely to
 * ReportPageForm.js, which owns the full two-column layout (illustration/
 * edit-form on the left, the actual form/observations on the right) - that
 * split needs live access to the same Formik instance on both sides (see
 * ReportPageForm.js's docblock), so it can't be split across two separate
 * components the way it used to be.
 */
export default function ReportPage(props) {
    const [owner, setOwner] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    // The asset-owner id in the URL, e.g. /report/fault/<ownerId>.
    const ownerId = props.id;

    useEffect(() => {
        getUserData(ownerId)
            .then(({ data }) => {
                // A well-formed but non-existent id resolves with `data: null`
                // (Mongoose `findById` found nothing) rather than an error -
                // both cases mean this link doesn't point to a real asset
                // owner, so both must be treated as "invalid link".
                if (!data) {
                    setIsError(true);
                } else {
                    setOwner(data);
                }
                setLoading(false);
            })
            .catch(() => {
                setIsError(true);
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ownerId]);

    if (loading || isError) {
        return (
            <div className="reportContainer bg-white">
                <div className="logoSection">
                    <Link to="/" className="logoSection__brand">
                        <img
                            src={toAbsoluteUrl("/media/client-logos/logo.png")}
                            alt="Anike"
                        />
                    </Link>
                    <img src={toAbsoluteUrl("/media/bg/bg-4.png")} alt="" />
                    <div className="opacity-70 font-weight-bold date">
                        &copy; {new Date().getFullYear()} Anike
                    </div>
                </div>

                <div className="formSection">
                    {loading && (
                        <div className="fault-report-status">
                            <div className="fault-report-status__spinner" />
                            <p>Loading the report form&hellip;</p>
                        </div>
                    )}

                    {isError && (
                        <div className="fault-report-status fault-report-status--error">
                            <h2>This link isn&rsquo;t valid</h2>
                            <p>
                                We couldn&rsquo;t find the maintenance provider this fault
                                report link points to. Please double check the link, or
                                contact whoever shared it with you for a new one.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return <ReportPageForm id={ownerId} owner={owner} />;
}


